<template>
  <div class="feishu-callback-container">
    <div class="callback-content">
      <div v-if="loading" class="loading-state">
        <i class="el-icon-loading" />
        <p>{{ $t('login.processing') }}</p>
      </div>

      <div v-else-if="success" class="success-state">
        <i class="el-icon-circle-check" />
        <p>{{ $t('login.codeSent') }}</p>
        <p class="tip">{{ $t('login.closingWindow') }}</p>
      </div>

      <div v-else class="error-state">
        <i class="el-icon-circle-close" />
        <p>{{ errorMessage || $t('login.invalidCode') }}</p>
        <p class="tip">{{ $t('login.closingWindow') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeishuCallback',
  data() {
    return {
      loading: true,
      success: false,
      errorMessage: ''
    };
  },
  async created() {
    await this.handleCallback();
  },
  methods: {
    async handleCallback() {
      const { code } = this.$route.query;

      if (!code) {
        this.loading = false;
        this.success = false;
        this.errorMessage = this.$t('login.invalidCode');
        this.closeWindow();
        return;
      }

      this.loading = false;
      this.success = true;
      this.notifyParent(code);
      this.closeWindow();
    },

    notifyParent(code) {
      try {
        if (window.opener) {
          window.opener.postMessage(
            {
              type: 'feishu-auth-code',
              code: code
            },
            window.location.origin
          );
        }
      } catch (error) {
        console.error('通知父页面失败:', error);
      }
    },

    closeWindow() {
      setTimeout(() => {
        try {
          window.close();
        } catch (error) {
          console.error('关闭窗口失败:', error);
        }
      }, 1000);
    }
  }
};
</script>

<style scoped lang="scss">
.feishu-callback-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;

  .callback-content {
    text-align: center;
    padding: 40px;

    .loading-state,
    .success-state,
    .error-state {
      i {
        font-size: 64px;
        margin-bottom: 20px;
      }

      p {
        font-size: 18px;
        color: #303133;
        margin: 10px 0;
      }

      .tip {
        font-size: 14px;
        color: #909399;
      }
    }

    .loading-state {
      i {
        color: #00A551;
      }
    }

    .success-state {
      i {
        color: #67c23a;
      }
    }

    .error-state {
      i {
        color: #f56c6c;
      }
    }
  }
}
</style>
